//Standard libraries
import React, { useEffect, useState } from "react";
import { StyledGrid, StyledIconButton } from "@hcl-commerce-store-sdk/react-component";
import { StyledBox, StyledTypography } from "../../styled-mui";
import { SvgClose } from "../svg/close";
//foundation
import { localStorageUtil } from "../../_foundation/utils/storageUtil";
import HTMLReactParser from "html-react-parser";
import { scrollToTop } from "../../utils/scrollToUtil";

/**
 * BannerInfo component
 */

interface BannerInfoProps {
  data: any;
  isLoading: boolean;
  error: any;
}

const BannerInfo: React.FC<BannerInfoProps> = ({ data, isLoading, error }) => {
  const [banner, setBanner] = useState<any>([]);
  const [isScrolling, setIsScrolling] = useState<boolean>(false);
  const textRef = React.useRef<HTMLDivElement>(null);

  const handleClose = (event) => {
    localStorageUtil.setBannerId(banner.map((b) => b.identifier).join("-"));
    setBanner(null);
    scrollToTop();
  };

  useEffect(() => {
    if (banner && textRef.current) {
      const checkOverflow = () => {
        const clientWidth = textRef.current?.parentElement?.clientWidth || 0;
        const scrollWidth = textRef.current?.scrollWidth || 0;
        setIsScrolling(scrollWidth > clientWidth);
      };

      checkOverflow();
      window.addEventListener("resize", checkOverflow);
      return () => window.removeEventListener("resize", checkOverflow);
    }
  }, [banner]);

  useEffect(() => {
    if (data) {
      const bannerContent = data?.bannerContents || [];
      const newBanner: any[] = [];
      bannerContent?.forEach((banner) => {
        if (banner != null) {
          const sDateStart = banner.dateStart;
          const sDateEnd = banner.dateEnd;
          const dateStart = Date.parse(sDateStart);
          const dateEnd = Date.parse(sDateEnd);
          const now = Date.now();
          if ((!sDateStart && !sDateEnd) || (dateStart <= now && dateEnd >= now)) {
            const newMessage = HTMLReactParser(banner.textDefilant);
            const ids = localStorageUtil.getBannerId();
            let find = false;
            ids?.split("-")?.forEach((id) => {
              if (id !== banner.id) {
                find = true;
                return;
              }
            });
            //
            if (!find) {
              newBanner.push({
                message: newMessage,
                identifier: banner.id,
              });
            }
          }
        }
      });

      if (newBanner.length > 0) {
        setBanner(newBanner);
        scrollToTop();
      }
    }
  }, [data]);

  if (isLoading || error) {
    return <></>;
  }

  return (
    <>
      {banner?.length > 0 && (
        <StyledGrid
          container
          id="header-banner"
          className="banner-info"
          px={{
            xs: 5,
            md: 6,
          }}>
          <StyledGrid item xs={12} pr={{ xs: "30px", md: 0 }}>
            <StyledBox className={`banner-info-scroll ${isScrolling ? "scrolling" : ""}`}>
              <StyledTypography
                variant="body2"
                component="div"
                className="banner-info-text"
                ref={textRef}>
                {banner.map((b, index) => (
                  <React.Fragment key={index}>{b.message}</React.Fragment>
                ))}
              </StyledTypography>
            </StyledBox>
            <StyledIconButton onClick={handleClose} className="banner-info-svg" title="Fermer">
              <SvgClose color="gray" className="" />
            </StyledIconButton>
          </StyledGrid>
        </StyledGrid>
      )}
    </>
  );
};

export default BannerInfo;
